import { AppState, ErrorState } from '../index';
import { createSelector } from '@ngrx/store';

const selectError = (state: AppState) => state.error;

export const selectedError = createSelector(selectError, (state: ErrorState) => state.error);
